import { supabase } from "@/config/supabase"
import { ApiError, mapSupabaseUser } from "@/types/domain.types"
import { User } from "@/types/user"

export class AuthService {
  static async login(email: string, password: string): Promise<{ user: User }> {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    })

    if (error) {
      throw new ApiError(error.message)
    }

    const user = mapSupabaseUser(data.user)
    if (!user) {
      throw new ApiError("Usuário não encontrado")
    }

    return { user }
  }

  static async loginWithMagicLink(email: string): Promise<void> {
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: `${window.location.origin}/auth/callback`,
      },
    })

    if (error) {
      throw new ApiError(error.message)
    }
  }

  static async changePassword(newPassword: string): Promise<void> {
    const { error } = await supabase.auth.updateUser({
      password: newPassword,
    })

    if (error) {
      throw new ApiError(error.message)
    }
  }

  static async register(data: {
    name: string
    email: string
    password: string
  }): Promise<{ user: User }> {
    console.log("Iniciando processo de registro");
    
    const { data: authData, error } = await supabase.auth.signUp({
      email: data.email,
      password: data.password,
      options: {
        data: {
          name: data.name,
          role: "user",
        },
      },
    })

    console.log("Resposta do signUp:", JSON.stringify(authData, null, 2));
    
    if (error) {
      console.error("Erro no signUp:", error);
      throw new ApiError(error.message)
    }

    if (authData.user) {
      console.log("Inserindo dados na tabela users com photo_url=null");
      
      const { error: userError } = await supabase
        .from('users')
        .upsert({
          id: authData.user.id,
          email: authData.user.email,
          name: data.name,
          role: 'user',
          photo_url: null,
        }, {
          onConflict: 'id'
        })

      if (userError) {
        console.error("Erro ao inserir na tabela users:", userError);
        console.error("Detalhes do erro:", {
          message: userError.message,
          details: userError.details,
          hint: userError.hint,
          code: userError.code
        });
        
        console.warn("Usuário criado no auth mas perfil não foi salvo na tabela users");
        console.warn("O usuário pode tentar fazer login e o perfil será criado automaticamente");
        
        console.log("Continuando com dados do auth user");
      } else {
        console.log("Inserção na tabela users concluída com sucesso");
      }
    }

    if (!authData.user) {
      console.error("Usuário não encontrado após signUp");
      throw new ApiError('Usuário não encontrado')
    }
    
    const user = mapSupabaseUser(authData.user)
    console.log("Usuário mapeado:", JSON.stringify(user, null, 2));
    
    if (!user) {
      console.error("Erro ao mapear usuário");
      throw new ApiError("Erro ao criar usuário")
    }

    return { user }
  }

  static async resetPassword(email: string): Promise<void> {
    const { error } = await supabase.auth.resetPasswordForEmail(email)

    if (error) {
      throw new ApiError(error.message)
    }
  }

  static async logout(): Promise<void> {
    const { error } = await supabase.auth.signOut()

    if (error) {
      throw new ApiError(error.message)
    }
  }
} 